const mapAndMergeApplePayShippingContactWithBillingContact = (shippingContact, billingContact) => {
  const isOnlyCompanyNameProvided = !!shippingContact.familyName && !shippingContact.givenName;
  const isContactProvidedExplicityInPaymentSheet = !!shippingContact.givenName && !!shippingContact.familyName;
  const configurableFields = {
    firstName: "",
    lastName: ""
  };
  if (isContactProvidedExplicityInPaymentSheet) {
    configurableFields.firstName = shippingContact.givenName || "";
    configurableFields.lastName = shippingContact.familyName || "";
  } else {
    configurableFields.firstName = billingContact.givenName || "";
    configurableFields.lastName = billingContact.familyName || "";
  }
  if (isOnlyCompanyNameProvided) {
    configurableFields.company = shippingContact.familyName;
  }
  return {
    streetName: shippingContact.addressLines?.[0] || "",
    streetNumber: shippingContact.addressLines?.[1] || "",
    additionalStreetInfo: shippingContact.addressLines?.[2] || "",
    postalCode: shippingContact?.postalCode || "",
    city: shippingContact?.locality || "",
    countryCode: shippingContact.countryCode || "",
    ...configurableFields,
    ...shippingContact.phoneNumber ? { phone: shippingContact.phoneNumber } : {},
    ...shippingContact?.subAdministrativeArea ? { region: shippingContact?.subAdministrativeArea } : {}
  };
};
export {
  mapAndMergeApplePayShippingContactWithBillingContact
};
//# sourceMappingURL=merge-apple-pay-contact-and-billing-address.js.map
